if (!customElements.get('main-blog-stores')) {
  customElements.define(
    'main-blog-stores',
    class Stores extends HTMLElement {
      constructor() {
        super();

        this.desktopMinWidth = 992;
        this.isDesktop = window.innerWidth >= this.desktopMinWidth;
        const { country, city } = this.getUrlSearchParams();

        /**
         * @type {HTMLSelectElement | null}
         */
        this.countrySelector = this.querySelector('#store-country');

        /**
         * @type {HTMLSelectElement | null}
         */
        this.citySelector = this.querySelector('#store-city');

        /**
         * @type {NodeListOf<HTMLElement>}
         */
        this.cities = this.querySelectorAll('.store-address');

        /**
         * @type {HTMLElement | null}
         */
        this.image = this.querySelector('.main-blog-stores__section-image_city');

        this.createCityOptions();
        this.sortCities();

        this.enterCityImage = (event) => this.toggleCityImage(event.currentTarget, true);
        this.leaveCityImage = (event) => this.toggleCityImage(event.currentTarget, false);

        if (this.countrySelector) {
          if (country) {
            this.countrySelector.value = country;
            this.onCountryChange();
            this.setSelectedValue(this.countrySelector, country);
          }
          this.countrySelector.addEventListener('change', this.onCountryChange.bind(this));
          this.onCountryChange();
        }

        if (this.citySelector) {
          if (city) {
            this.citySelector.value = city;
            this.onCityChange();
            this.setSelectedValue(this.citySelector, city);
          }
          this.citySelector.addEventListener('change', this.onCityChange.bind(this));
        }

        window.addEventListener('resize', this.onWindowResize.bind(this));
        this.toggleCityImageEvents();
      }

      /**
       * If script triggers before site-select script, make sure the select__selected has the correct value
       *
       * @param {HTMLSelectElement} selector
       * @param {string} value
       */
      setSelectedValue(selector, value) {
        const label = selector.parentNode?.querySelector('.select__selected');
        if (label) {
          label.innerHTML = value;
        }
      }

      /**
       *
       * @param {string} key
       * @param {string} value
       */
      setUrlSearchParams(key, value) {
        const url = new URL(window.location.href);
        url.searchParams.set(key, value);
        window.history.pushState({}, '', url);
      }

      getUrlSearchParams() {
        const url = new URL(window.location.href);
        const country = url.searchParams.get('country');
        const city = url.searchParams.get('city');
        return { country, city };
      }

      onCountryChange() {
        if (!this.countrySelector) return;
        const selectedCountry = this.countrySelector.options[this.countrySelector.selectedIndex].value;
        this.setUrlSearchParams('country', selectedCountry);
        this.createCityOptions();
      }

      clearCitySelector() {
        if (!this.citySelector) return;
        this.citySelector.innerHTML = '';
      }

      setCity(index = 0) {
        if (!this.citySelector) return;
        this.citySelector.selectedIndex = index;
        this.citySelector.dispatchEvent(new Event('change'));
      }

      onCityChange() {
        if (!this.citySelector) return;

        const selectedCity = this.citySelector.options[this.citySelector.selectedIndex].value;
        this.setUrlSearchParams('city', selectedCity);

        this.cities.forEach((city) => {
          city.classList.toggle('util-hidden', city.getAttribute('data-city') !== selectedCity);
        });

        this.sortCities();
      }

      onWindowResize() {
        const wasDesktop = this.isDesktop;
        this.isDesktop = window.innerWidth >= this.desktopMinWidth;
        if (wasDesktop !== this.isDesktop) {
          this.toggleCityImageEvents();
        }
      }

      toggleCityImageEvents() {
        this.cities.forEach((city) => {
          // Remove existing listeners to avoid duplicates
          city.removeEventListener('mouseenter', this.enterCityImage);
          city.removeEventListener('mouseleave', this.leaveCityImage);

          if (this.isDesktop) {
            city.addEventListener('mouseenter', this.enterCityImage);
            city.addEventListener('mouseleave', this.leaveCityImage);
          }
        });
      }

      /**
       * @param {HTMLElement} city
       * @param {boolean} show
       */
      toggleCityImage(city, show) {
        const template = city.querySelector('.store-address__template');
        if (!this.image || !template) return;

        this.image.innerHTML = show ? template.innerHTML : '';
      }

      sortCities() {
        const hiddenCities = Array.from(this.cities).filter((city) => city.classList.contains('util-hidden'));
        hiddenCities.forEach((city) => {
          city.parentNode?.appendChild(city);
        });
      }

      /**
       *
       * @param {string} value
       * @param {string | undefined} text
       * @returns {HTMLOptionElement}
       */
      createOption(value, text = undefined) {
        const option = document.createElement('option');
        option.value = value;
        option.innerHTML = text || value;

        return option;
      }

      createCityOptions() {
        this.clearCitySelector();
        const selectedIndex = this.countrySelector?.selectedIndex || 0;
        const selectedOption = this.countrySelector?.options[selectedIndex] || document.createElement('option');

        const raw = selectedOption.getAttribute('data-cities') || '[]';

        /**
         * @type {string[]}
         */
        const cities = JSON.parse(raw);

        this.citySelector?.appendChild(this.createOption('', this.getAttribute('city-select') || '---'));
        cities.forEach((city) => {
          this.citySelector?.appendChild(this.createOption(city));
        });

        if (cities.length === 1) {
          this.setCity(1);
          this.onCityChange();
        } else {
          this.setCity(0);
        }
      }
    },
  );
}
